import { TFunction } from "i18next";
import { IOptions } from "../../Admin";

export default function leagueOptions(t: TFunction<"translation", undefined>, leagueId: number): IOptions[] {
  if (isNaN(leagueId)) {
    return [];
  } else {
    return [
      {
        label: t("secure.facility.league.league_menu.001"),
        url: `/admin/league/${leagueId}/home`,
      },
      {
        label: t("secure.facility.league.league_menu.013"),
        url: `/admin/league/${leagueId}/players`,
      },
      {
        label: t("secure.facility.league.league_menu.014"),
        url: `/admin/league/${leagueId}/announcements`,
      },
      {
        label: t("secure.facility.league.league_menu.003"),
        url: process.env.REACT_APP_SCORING_URL,
        urlNewTab: true,
      },

      {
        label: t("secure.facility.league.league_menu.005"),
        url: `/admin/league/${leagueId}/league-settings`,
        subOptions: [
          {
            label: t("secure.facility.league.league_menu.017"),
            url: `/admin/league/${leagueId}/league-settings/general`,
          },
          {
            label: t("secure.facility.league.league_menu.018"),
            url: `/admin/league/${leagueId}/league-settings/registration`,
          },
          {
            label: t("secure.facility.league.league_menu.019"),
            url: `/admin/league/${leagueId}/league-settings/organizers`,
          },
          {
            label: t("Format Templates"),
            url: `/admin/league/${leagueId}/league-settings/format-templates`,
          },
          {
            label: t("secure.facility.league.league_menu.021"),
            url: `/admin/league/${leagueId}/league-settings/teetimes`,
          },
          {
            label: t("secure.facility.league.league_menu.022"),
            url: `/admin/league/${leagueId}/prizeAccounts`,
          },
        ],
      },
    ];
  }
}
